import React from "react";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";
import { withSnackbar } from "notistack";

const DismissSnackbar = props => {
  return (
    <IconButton
      aria-label="cancel"
      onClick={() => {
        props.closeSnackbar(props.snackBarId);
      }}
    >
      <CancelIcon />
    </IconButton>
  );
};

export default withSnackbar(DismissSnackbar);
